import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page91() {
  useEffect(() => {
    document.title = "Маяк — Страница 90"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page89" />
        <ForwardLink href="/page91" />
      </div>

      <p style={{ textAlign: "right" }}>90.</p>
      <p>СТАРИК ДИКО УХМЫЛЯЕТСЯ... МОЛОДОЙ УХМЫЛЯЕТСЯ В ОТВЕТ...</p>
      <p>МОЛОДОЙ НАЧИНАЕТ ПИНАТЬ СТАРИКА В БОЛЬНУЮ НОГУ...</p>
      <p>СТАРИК ПАДАЕТ НА ЗЕМЛЮ -- он пытается встать...</p>
      <p>МОЛОДОЙ ПИНАЕТ СТАРИКА В ХРЕБЕТ...</p>
      <p>ЛОБ СТАРИКА УДАРЯЕТСЯ О ПОЛ. СИЛЬНО. Идет кровь.</p>
      <p>
        МОЛОДОЙ САДИТСЯ СВЕРХУ НА СТАРИКА И ПЕРЕВОРАЧИВАЕТ ЕГО. СТАРИК ХВАТАЕТ<br/>
        МОЛОДОГО ЗА ПЛЕЧИ.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Заткнись! Заткнись! Заткнись!
      </p>
      <p>
        ОНИ ЯРОСТНО БОРЮТСЯ... ЖИВОТНОЕ ХРЮКАНЬЕ...<br/>
        ДЫХАНИЕ... ПОТ... НОГИ ПЕРЕПЛЕЛИСЬ... ЖИЛИСТЫЕ ГЛОТКИ...<br/>
        ЖИЛИСТЫЕ БИЦЕПСЫ...
      </p>
      <p>ТО ТУДА, ТО СЮДА, ТО ТУДА, ТО СЮДА...</p>
      <p>БОРЬБА... ДЫХАНИЕ... ХРЮКАНЬЕ... ПОТ...</p>
      <p>ВНЕЗАПНО МОЛОДОЙ СМОТРИТ ВНИЗ... ЭТО БОЛЬШЕ НЕ СТАРИК...</p>
      <p>ЭТО <u>ЭФРАИМ</u> <u>УИНСЛОУ</u> в своем пальто макино...</p>
      <p>МОЛОДОЙ В УЖАСЕ...</p>
      <p>УИНСЛОУ ПЛЮЕТ МОЛОДОМУ В ЛИЦО...</p>
      <p>
        МОЛОДОЙ НАЧИНАЕТ ДУШИТЬ ЕГО, НО КАК ТОЛЬКО ОН ЭТО ДЕЛАЕТ... УИНСЛОУ<br/>
        СТАНОВИТСЯ...
      </p>
      <p><u>РУСАЛКОЙ</u>! ОНА ДУШИТ МОЛОДОГО... БЬЕТ ХВОСТОМ...</p>
      <p>ОН ПЫТАЕТСЯ СБЕЖАТЬ...</p>
      <p>ЗАТЕМ РУСАЛКА СТАНОВИТСЯ...</p>
      <p><u>СТАРИКОМ</u>...</p>
      <p>
        ТОЛЬКО НЕ СОВСЕМ: ОН ГОЛЫЙ, ЕГО БОРОДА ДЛИНЕЕЕ, ПОКРЫТА<br/>
        ВОДОРОСЛЯМИ... И У НЕГО <u>ОГРОМНЫЕ</u> <u>ЩУПАЛЬЦА</u> <u>КАЛЬМАРА</u> ВМЕСТО НОГ...
      </p>
      <p>МОЛОДОЙ УДАРЯЕТ СТАРИКА, И ИЗ ЕГО РТА ВЫТЕКАЕТ МОРСКАЯ ВОДА...</p>
      <p>
        СТАРИК СМЕЕТСЯ... ОБВИВАЯ СВОИМИ ЩУПАЛЬЦАМИ МОЛОДОГО... ОБХВАТЫВАЯ<br/>
        ЕГО РУКИ И НОГИ, СЖИМАЯ...
      </p>
      <p>МОЛОДОЙ УДАРЯЕТ СТАРИКА СНОВА, ЖЕСТКО!</p>
      <p>ЩУПАЛЬЦЕ ОБВИВАЕТ ГОРЛО МОЛОДОГО, СЖИМАЕТ...</p>
      <p style={{ textAlign: "right" }}>90.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page89" />
        <ForwardLink href="/page91" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710718338/the-lighthouse-script/cke5grfngymiqircb5if.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page91;
